import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from '../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingComponent } from './loading/loading.component';
import { ErrorComponent } from './error/error.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { AreYouSureComponent } from './modals/are-you-sure/are-you-sure.component';
import { CreatePostButtonComponent } from './bottoms/create-post-button/create-post-button.component';
import { CreatePostModalComponent } from './modals/create-post-modal/create-post-modal.component';
import { ImageModalComponent } from './modals/image-modal/image-modal.component';
import { ReportComponent } from './modals/report/report.component';
import { MostLoginComponent } from './modals/most-login/most-login.component';
import { RouterModule } from '@angular/router';
import { ReportResultComponent } from './modals/report-result/report-result.component';
import { PersonalInfoComponent } from './modals/edit-about/personal-info/personal-info.component';
import { PipsModule } from '../pips/pips.module';
import { RatingComponent } from './rating/rating.component';
import { EduCertComponent } from './modals/edit-about/edu-cert/edu-cert.component';
import { CertComponent } from './modals/edit-about/cert/cert.component';
import { WorkComponent } from './modals/edit-about/work/work.component';
import { SkillComponent } from './modals/edit-about/skill/skill.component';
import { LanguageComponent } from './modals/edit-about/language/language.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SkePostComponent } from './skeleton/ske-post/ske-post.component';
import { SkeProfileHeaderComponent } from './skeleton/ske-profile-header/ske-profile-header.component';
import { SkeMagazineBoxComponent } from './skeleton/ske-magazine-box/ske-magazine-box.component';
import { SkeEntityBoxComponent } from './skeleton/ske-entity-box/ske-entity-box.component';
import { SkeListComponent } from './skeleton/ske-exam/ske-list/ske-list.component';
import { SkeSortingComponent } from './skeleton/ske-exam/ske-sorting/ske-sorting.component';
import { SkeCriteriaComponent } from './skeleton/ske-exam/ske-criteria/ske-criteria.component';
import { SkeAboutMeComponent } from './skeleton/ske-about-entity/ske-about-me/ske-about-me.component';
import { SkeAboutEntityListComponent } from './skeleton/ske-about-entity/ske-about-entity-list/ske-about-entity-list.component';
import { SkeAboutLanguageSkillComponent } from './skeleton/ske-about-entity/ske-about-language-skill/ske-about-language-skill.component';
import { LyImageCropperModule } from '@alyle/ui/image-cropper';
import { SkeExamExplainComponent } from './skeleton/ske-exam-explain/ske-exam-explain.component';
import { CreateMagazinePostModalComponent } from './modals/create-magazine-post-modal/create-magazine-post-modal.component';
import { TimeModalComponent } from './modals/time-modal/time-modal.component';
import { PostRefrenceModalComponent } from './modals/post-refrence-modal/post-refrence-modal.component';
import { PostCategoryModalComponent } from './modals/post-category-modal/post-category-modal.component';
import { ExamInfoComponent } from './exam/exam-info/exam-info.component';
import { LikertComponent } from './exam/question/likert/likert.component';
import { SortingComponent } from './exam/question/sorting/sorting.component';
import { MultiOptionComponent } from './exam/question/multi-option/multi-option.component';
import { HorizontalBarComponent } from './exam/results/horizontal-bar/horizontal-bar.component';
import { PieComponent } from './exam/results/pie/pie.component';
import { QuestionListComponent } from './exam/question/question-list/question-list.component';
import { SkeWalletBoxComponent } from './skeleton/ske-wallet-box/ske-wallet-box.component';
import { SkeTransactionComponent } from './skeleton/ske-transaction/ske-transaction.component';
import { ExpandSecComponent } from './exam/question/expand-sec/expand-sec.component';
import { QuizComponent } from './exam/question/quiz/quiz.component';
import { ExamLoadingComponent } from './exam/exam-loading/exam-loading.component';
import { ResultsComponent } from './exam/results/results/results.component';
import { CountUpModule } from 'ngx-countup';
import { PolarComponent } from './exam/results/polar/polar.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { VagueQuestionWarnComponent } from './modals/vague-question-warn/vague-question-warn.component';
import { FinishComponent } from './exam/question/finish/finish.component';
import { ReduceUnknownQuestionComponent } from './exam/question/reduce-unknown-question/reduce-unknown-question.component';
import { HatchSkinComponent } from './exam/question/hatch-skin/hatch-skin.component';
import { SideLinkComponent } from './side-link/side-link.component';
import { SkeEditInfoComponent } from './skeleton/ske-edit-info/ske-edit-info.component';
import { SearchSelectComponent } from './search-select/search-select.component';
import { MobileSelectionComponent } from './search-select/mobile-selection/mobile-selection.component';
import { CreateItemComponent } from './search-select/create-item/create-item.component';
import { SkeSingleNotificationComponent } from './skeleton/ske-single-notification/ske-single-notification.component';
import { SkeNotificationComponent } from './skeleton/ske-notification/ske-notification.component';
import { TableComponent } from './table/table.component';
import { SkeTableComponent } from './skeleton/ske-table/ske-table.component';
import { SkeStepperComponent } from './skeleton/ske-stepper/ske-stepper.component';
import { BackHeaderComponent } from './back-header/back-header.component';
import { SlideToggleButtonComponent } from './slide-toggle-button/slide-toggle-button.component';
import { AdvancedSearchComponent } from './advanced-search/advanced-search.component';
import { RsdButtonCoponent } from './bottoms/rsd-button/rsd-button.component';
import { NgPersianDatepickerModule } from 'ng-persian-datepicker';
import { MultiLayerLinksComponent } from './multi-layer-links/multi-layer-links.component';
import { LinkContainerComponent } from './multi-layer-links/link-container/link-container.component';
import { FullscreenLoadingComponent } from './fullscreen-loading/fullscreen-loading.component';
import { ColumnBoxSkeletonComponent } from './skeleton/column-box-skeleton/column-box-skeleton.component';
import { ReportCardSettingComponent } from './modals/report-card-setting/report-card-setting.component';
import { ReportCardHandlerComponent } from './report-card-handler/report-card-handler.component';
import { AnalyserListModalComponent } from './modals/analyser-list-modal/analyser-list-modal.component';
import { SkePlanBoxComponent } from './skeleton/ske-plan-box/ske-plan-box.component';
import { SkeReviewerComponent } from './skeleton/ske-reviewer/ske-reviewer.component';
import { SkeEntityMemberComponent } from './skeleton/ske-entity-member/ske-entity-member.component';
import { TransformToPersianDirective } from '../directives/transform-to-persian.directive';
import { CodeVerificationComponent } from './code-verification/code-verification.component';
import { SoftwareComponent } from './modals/edit-about/software/software.component';
import { PrivateComponent } from './modals/edit-about/private/private.component';
import { AwardComponent } from './modals/edit-about/award/award.component';
import { ProjectComponent } from './modals/edit-about/project/project.component';
import { PublicationComponent } from './modals/edit-about/publication/publication.component';
import { VoluntaryComponent } from './modals/edit-about/voluntary/voluntary.component';
import { DropButtonComponent } from './drop-button/drop-button.component';
import { ShowImageComponent } from './modals/show-image/show-image.component';
import { TraitRoleModalComponent } from './modals/trait-role-modal/trait-role-modal.component';
import { SkeSideLinkMenuComponent } from './skeleton/ske-side-link-menu/ske-side-link-menu.component';
import { AuditModalComponent } from './modals/audit-modal/audit-modal.component';
import { ReceiptPaymentComponent } from './modals/receipt-payment/receipt-payment.component';
import { NotifStructureComponent } from './notif-structure/notif-structure.component';
import { ChargeProgramComponent } from './modals/charge-program/charge-program.component';
import { ChangeStyleModalComponent } from './modals/change-style-modal/change-style-modal.component';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [
    LoadingComponent,
    ErrorComponent,
    AreYouSureComponent,
    CreatePostButtonComponent,
    CreatePostModalComponent,
    ImageModalComponent,
    ReportComponent,
    MostLoginComponent,
    ReportResultComponent,
    PersonalInfoComponent,
    RatingComponent,
    EduCertComponent,
    CertComponent,
    WorkComponent,
    SkillComponent,
    LanguageComponent,
    SkePostComponent,
    SkeProfileHeaderComponent,
    SkeMagazineBoxComponent,
    SkeEntityBoxComponent,
    SkeListComponent,
    SkeSortingComponent,
    SkeCriteriaComponent,
    SkeAboutMeComponent,
    SkeAboutEntityListComponent,
    SkeAboutLanguageSkillComponent,
    SkeExamExplainComponent,
    SkeSingleNotificationComponent,
    CreateMagazinePostModalComponent,
    TimeModalComponent,
    PostRefrenceModalComponent,
    PostCategoryModalComponent,
    ExamInfoComponent,
    LikertComponent,
    SortingComponent,
    MultiOptionComponent,
    HorizontalBarComponent,
    PieComponent,
    PolarComponent,
    QuestionListComponent,
    SkeWalletBoxComponent,
    SkeTransactionComponent,
    ExpandSecComponent,
    QuizComponent,
    ExamLoadingComponent,
    ResultsComponent,
    VagueQuestionWarnComponent,
    FinishComponent,
    ReduceUnknownQuestionComponent,
    HatchSkinComponent,
    SideLinkComponent,
    SkeEditInfoComponent,
    SearchSelectComponent,
    MobileSelectionComponent,
    CreateItemComponent,
    SkeNotificationComponent,
    TableComponent,
    SkeTableComponent,
    SkeStepperComponent,
    BackHeaderComponent,
    SlideToggleButtonComponent,
    AdvancedSearchComponent,
    RsdButtonCoponent,
    MultiLayerLinksComponent,
    LinkContainerComponent,
    FullscreenLoadingComponent,
    ColumnBoxSkeletonComponent,
    ReportCardSettingComponent,
    ReportCardHandlerComponent,
    AnalyserListModalComponent,
    SkePlanBoxComponent,
    SkeReviewerComponent,
    SkeEntityMemberComponent,
    TransformToPersianDirective,
    CodeVerificationComponent,
    SoftwareComponent,
    PrivateComponent,
    AwardComponent,
    ProjectComponent,
    PublicationComponent,
    VoluntaryComponent,
    DropButtonComponent,
    ShowImageComponent,
    TraitRoleModalComponent,
    SkeSideLinkMenuComponent,
    AuditModalComponent,
    ReceiptPaymentComponent,
    NotifStructureComponent,
    ChargeProgramComponent,
    ChangeStyleModalComponent,
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    LyImageCropperModule,
    AngularEditorModule,
    PipsModule,
    RouterModule,
    NgxSkeletonLoaderModule.forRoot(),
    CountUpModule,
    HighchartsChartModule,
    NgPersianDatepickerModule,
    MatDialogModule,
  ],
  exports: [
    NotifStructureComponent,
    ShowImageComponent,
    TransformToPersianDirective,
    LoadingComponent,
    ErrorComponent,
    CreatePostButtonComponent,
    CreatePostModalComponent,
    AreYouSureComponent,
    PersonalInfoComponent,
    RatingComponent,
    EduCertComponent,
    CertComponent,
    WorkComponent,
    SkillComponent,
    LanguageComponent,
    SkePostComponent,
    SkeProfileHeaderComponent,
    SkeMagazineBoxComponent,
    SkeEntityBoxComponent,
    SkeListComponent,
    SkeSortingComponent,
    SkeCriteriaComponent,
    SkeAboutMeComponent,
    SkeSingleNotificationComponent,
    SkeAboutEntityListComponent,
    SkeAboutLanguageSkillComponent,
    SkeExamExplainComponent,
    CreateMagazinePostModalComponent,
    TimeModalComponent,
    PostRefrenceModalComponent,
    PostCategoryModalComponent,
    ExamInfoComponent,
    QuestionListComponent,
    SkeWalletBoxComponent,
    SkeTransactionComponent,
    QuizComponent,
    ExamLoadingComponent,
    ResultsComponent,
    HorizontalBarComponent,
    PieComponent,
    PolarComponent,
    SideLinkComponent,
    SkeEditInfoComponent,
    SearchSelectComponent,
    AngularEditorModule,
    SkeNotificationComponent,
    TableComponent,
    SkeTableComponent,
    SkeStepperComponent,
    BackHeaderComponent,
    SlideToggleButtonComponent,
    HatchSkinComponent,
    AdvancedSearchComponent,
    RsdButtonCoponent,
    NgPersianDatepickerModule,
    MultiLayerLinksComponent,
    FullscreenLoadingComponent,
    ColumnBoxSkeletonComponent,
    ReportCardSettingComponent,
    ReportCardHandlerComponent,
    AnalyserListModalComponent,
    SkePlanBoxComponent,
    SkeReviewerComponent,
    SkeEntityMemberComponent,
    CodeVerificationComponent,
    SoftwareComponent,
    PrivateComponent,
    AwardComponent,
    ProjectComponent,
    PublicationComponent,
    VoluntaryComponent,
    DropButtonComponent,
    TraitRoleModalComponent,
    SkeSideLinkMenuComponent,
    AuditModalComponent,
    ReceiptPaymentComponent,
    ChargeProgramComponent
  ]
})
export class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule
    }
  }
}